import { createSlice } from '@reduxjs/toolkit'

export interface TokenState {
    token: string | undefined
}

const tokenInitialState: TokenState = {
    token: undefined
}

const tokenSlice = createSlice({
    name: 'token',
    initialState: tokenInitialState,
    reducers: {
        setToken(state, action) {
            state.token =  action.payload
        }
    }
})

export const { setToken } = tokenSlice.actions
export default tokenSlice.reducer
